import { render, staticRenderFns } from "./SupervisorPermissionsCell.vue?vue&type=template&id=68a30f24&scoped=true&"
import script from "./SupervisorPermissionsCell.vue?vue&type=script&lang=js&"
export * from "./SupervisorPermissionsCell.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorPermissionsCell.vue?vue&type=style&index=0&id=68a30f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a30f24",
  null
  
)

export default component.exports